import { stats } from "../data";

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-50">
      <div className="site-container py-12 md:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {stats.map((s, idx) => (
            <div
              key={s.label}
              className="relative rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 text-left"
            >
              {idx === 0 ? (
                <span className="absolute inset-x-0 top-0 h-1 rounded-t-lg bg-accent-500"></span>
              ) : null}
              <p className="font-serif text-3xl md:text-4xl font-black text-primary-600">{s.num}</p>
              <h3 className="mt-2 text-sm md:text-base font-bold text-foreground-950">{s.label}</h3>
              <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-500">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}